
import React, { useState,useEffect } from "react";
import { AiOutlineMenuUnfold, AiOutlineMenuFold} from "react-icons/ai";
import { Link,useParams } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import Header from "./Header";
import { JavaOutlined } from "@ant-design/icons";
import { FiActivity } from 'react-icons/fi';
import { MdWorkOutline } from "react-icons/md";
import { AiOutlineUserAdd } from "react-icons/ai";
import { ReadOutlined } from "@ant-design/icons";

const UserNavBar = ({ setActivePage,loggedInUserId }) => {
  const [open, setOpen] = useState(true); // State to manage sidebar open/close
const[userData,setUserData]=useState(null);
const[loading, setLoading]=useState(true);
const{id}=useParams();
const userIdToFetch=id||loggedInUserId;

console.log("id ------------------",userIdToFetch);
useEffect(() => {
  const fetchUserData = async () => {
    // try {
      setLoading(true);
      const storedUser = JSON.parse(localStorage.getItem("userEmail"));
      // const response = await fetch("/employeeData.json");  // Assuming the data is in this JSON file
      // const data = await response.json();
      // //Giving the Id directly it is working, fetching from the json is not working
      // const user = data.find(item => item.id === userIdToFetch);
      // if(user){
              setUserData(storedUser);
// }
// else{
//   console.error("User not found");
// }
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//     }finally{
//       setLoading(false);
//     }
   };
  
 // fetchUserData();
}, []);

  const menus = [
    { name: "User View", link: `/ViewPage`, icon: FaUserCircle,},
  // ];:[{name: "User View", link: `/ViewPage/${userIdToFetch}`,icon:FaUserCircle,},
 //{ name: "Account Activity", link: `/useraccountactivity`, icon: FiActivity },
  // { name: "Account Activity", link: `/useraccountactivity/U30001`, icon: FiActivity },
      { name: "Job Search", link: "/SearchJob", icon: AiOutlineUserAdd },
     { name: "Training Portal", link: `/SearchTraining`, icon: ReadOutlined }
];

  // ✅ Default: Normal User Sidebar
  return (
    <section className="flex gap-6">
      <Header />
      <div className={`bg-white h-[calc(100vh-70px)] ${open ? "w-72" : "w-16"} duration-500 text-black-100 px-4 top-[70px] left-0 overflow-y-auto fixed shadow-md`}>
        <div className="py-3 flex justify-end">
          {open ? (
            <AiOutlineMenuFold size={26} className="cursor-pointer" onClick={() => setOpen(false)} />
          ) : (
            <AiOutlineMenuUnfold size={26} className="cursor-pointer" onClick={() => setOpen(true)} />
          )}
        </div>
        <div className="mt-4 flex flex-col gap-4 relative">
          {menus.map((menu, i) => (
            <Link
              to={menu.link}
              key={i}
              className="flex items-center text-sm gap-3.5 font-bold p-2 hover:bg-[#1f415b] rounded-md cursor-pointer text-gray-500 hover:text-white"
            >
              <div>{React.createElement(menu.icon, { size: "20" })}</div>
              <h2
                style={{ transitionDelay: `${i + 3}00ms` }}
                className={`mt-3 whitespace-pre duration-500 ${!open && "opacity-0 translate-x-28 overflow-hidden"}`}
              >
                {menu.name}
              </h2>
            </Link>
          ))}
        </div>
      </div>
      <div className={`transition-all duration-500 flex p-3 bg-[#eaf5ff] ${open ? 'pl-72' : 'pl-16'} ml-0 w-[100%]`} style={{ height: '590px' }}>
      </div>
    </section>
  );
};

export default UserNavBar;
